import { render, staticRenderFns } from "./WorkspaceFabricSetScale.vue?vue&type=template&id=d8c067b4&scoped=true&"
import script from "./WorkspaceFabricSetScale.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricSetScale.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricSetScale.vue?vue&type=style&index=0&id=d8c067b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c067b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c067b4')) {
      api.createRecord('d8c067b4', component.options)
    } else {
      api.reload('d8c067b4', component.options)
    }
    module.hot.accept("./WorkspaceFabricSetScale.vue?vue&type=template&id=d8c067b4&scoped=true&", function () {
      api.rerender('d8c067b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricSetScale.vue"
export default component.exports